/*
 *
 * Theme: `@dbh/paginator`.
 *
 */const THEME_KEY_PAGINATOR="paginator",modifyPaginatorTheme=a=>{let{colors:{white:b,brandSecond:c}}=a;return {[THEME_KEY_PAGINATOR]:{textThemefontSizeName:"ff7",active:{backgroundColor:c,textColor:b,textThemeColorName:"white"},inactive:{textThemeColorName:"grey"}}}};

export { modifyPaginatorTheme as default };
